import { render } from "./BasicUser.vue?vue&type=template&id=641f3812&scoped=true"
import script from "./BasicUser.vue?vue&type=script&lang=js"
export * from "./BasicUser.vue?vue&type=script&lang=js"

import "./BasicUser.vue?vue&type=style&index=0&id=641f3812&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-641f3812"]])

export default __exports__